.container {
	position: fixed;
	bottom: 1.5rem;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	z-index: 1001;
	pointer-events: none;
}

.toast {
	box-shadow: 0 0 50px var(--shadow);
	background: var(--system);
	padding: 0.75rem 1.5rem;
	border-radius: 1em;
	font-size: 0.875rem;
	animation: slideUp 0.2s ease-out;
	pointer-events: auto;
}

@keyframes slideUp {
	from {
		opacity: 0;
		transform: translateY(1rem);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.hiding {
	animation: slideDown 0.2s ease-in forwards;
}

@keyframes slideDown {
	to {
		opacity: 0;
		transform: translateY(1rem);
	}
}

.error {
  background: #ff6b6b;
  color: #fff;
}
